<template>
  <div class="datenschutz">
    <h1>Datenschutzerklärung</h1>
    <h2>1. Allgemeine Hinweise</h2>
    <p>Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Diese Datenschutzerklärung informiert Sie darüber, welche Daten wir erheben und wie wir sie verwenden.</p>
    
    <h2>2. Verantwortliche Stelle</h2>
    <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
    <p>Maike Röhrig<br>Maikes Familienbegleitung<br>Trierer Str. 250A<br>56072 Koblenz<br>Email: info@maikes-familienbegleitung.de</p>
    
    <h2>3. Hosting und Server-Logfiles</h2>
    <p>Diese Website wird bei Google Firebase gehostet. Beim Besuch der Website speichert der Webserver automatisch sogenannte Server-Logfiles. Diese enthalten unter anderem:</p>
    <ul>
      <li>Ihre IP-Adresse (anonymisiert, sofern möglich)</li>
      <li>Datum und Uhrzeit des Zugriffs</li>
      <li>Name der angeforderten Datei</li>
      <li>Übertragene Datenmenge</li>
      <li>Verweisende URL (falls zutreffend)</li>
      <li>Browsertyp und -version</li>
    </ul>
    <p>Diese Daten dienen ausschließlich der Sicherstellung des Betriebs und der Sicherheit der Website. Eine Zusammenführung dieser Daten mit anderen Datenquellen erfolgt nicht.</p>
    
    <h2>4. Kontaktaufnahme</h2>
    <p>Falls Sie uns kontaktieren, werden die von Ihnen übermittelten Daten ausschließlich zur Bearbeitung Ihrer Anfrage genutzt. Es erfolgt keine Weitergabe an Dritte.</p>
    
    <h2>5. Rechte der betroffenen Personen</h2>
    <p>Da diese Website bei Google Firebase gehostet wird, werden technische Daten wie Server-Logs direkt von Google verarbeitet. Die Betreiber dieser Website haben keinen Zugriff auf diese Daten und können keine Auskünfte, Löschungen oder Berichtigungen vornehmen.</p>
    <p>Weitere Informationen zur Datenverarbeitung durch Google finden Sie in der <a href="https://policies.google.com/privacy?hl=de" target="_blank">Datenschutzrichtlinie von Google</a>.</p>
    
    <h2>6. Änderungen der Datenschutzerklärung</h2>
    <p>Diese Datenschutzerklärung kann aufgrund gesetzlicher Änderungen angepasst werden. Bitte informieren Sie sich regelmäßig über den aktuellen Stand.</p>
    
    <p><strong>Stand: April 2026</strong></p>
  </div>
</template>

<script>
export default {
  name: 'Datenschutz'
}
</script>

<style scoped>
.datenschutz {
}
</style>